/**
 * 图片滤镜 SYSTEM 插件注册入口
 *
 * 注册控制器、按编辑器隔离的 Store 和自定义历史，不渲染核心 UI。
 */
import { PluginType, type IExportPlugin } from '@/version-types';
import { ImageFilterPlugin } from './controller';
import { ImageFilterHistory } from './history';
import imageFilterState from './state';
import { IMAGE_FILTER_PLUGIN_KEY } from './types';

/** 图片滤镜插件注册描述。 */
const imageFilterPlugin: IExportPlugin = {
    type: PluginType.SYSTEM,
    sort: 10,
    name: 'image-filter',
    render() {
        return null;
    },
    createState() {
        return [imageFilterState];
    },
    createHistory({ identity }) {
        return [new ImageFilterHistory(identity)];
    },
    createInstance({ identity }) {
        return [{ key: IMAGE_FILTER_PLUGIN_KEY, value: new ImageFilterPlugin(identity) }];
    },
    destroy({ getInstance }) {
        getInstance<ImageFilterPlugin>(IMAGE_FILTER_PLUGIN_KEY)?.dispose();
    },
};

export default imageFilterPlugin;
